import { QualificationState } from "@reducers/types/HRM/qualification-state";

import { QualificationActions } from "@actions/HRM/employee/qualification-actions";
import {
  GET_QUALIFICATION,
  UPDATE_EDUCATION_INFO,
  UPDATE_LOCAL_TRAINING_INFO,
  UPDATE_FOREIGN_TRAINING_INFO,
  UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO,
  UPDATE_PUBLICATION_INFO,
  UPDATE_HONOUR_INFO,
  UPDATE_REWARD_INFO,
  DELETE_EDUCATION_INFO,
  DELETE_LOCAL_TRAINING_INFO,
  DELETE_FOREIGN_TRAINING_INFO,
  DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO,
  DELETE_PUBLICATION_INFO,
  DELETE_HONOUR_INFO,
  DELETE_REWARD_INFO,
} from "@actions/HRM/employee/types";

import {
  getInitialState,
  getFailedState,
  getRequestingState,
  getSuccessState,
} from "@utils/store";

const initialState: QualificationState = { ...getInitialState() };

const resetStates = {
  updateEducationRequestOngoing: false,
  updateEducationSuccess: false,
  updateEducationFailed: false,

  updateLocalTrainingRequestOngoing: false,
  updateLocalTrainingSuccess: false,
  updateLocalTrainingFailed: false,

  updateForeignTrainingRequestOngoing: false,
  updateForeignTrainingSuccess: false,
  updateForeignTrainingFailed: false,

  updateAdditionalProfessionalQualificationRequestOngoing: false,
  updateAdditionalProfessionalQualificationSuccess: false,
  updateAdditionalProfessionalQualificationFailed: false,

  updatePublicationRequestOngoing: false,
  updatePublicationSuccess: false,
  updatePublicationFailed: false,

  updateHonourRequestOngoing: false,
  updateHonourSuccess: false,
  updateHonourFailed: false,

  updateRewardRequestOngoing: false,
  updateRewardSuccess: false,
  updateRewardFailed: false,

  deleteEducationRequestOngoing: false,
  deleteEducationSuccess: false,
  deleteEducationFailed: false,

  deleteLocalTrainingRequestOngoing: false,
  deleteLocalTrainingSuccess: false,
  deleteLocalTrainingFailed: false,

  deleteForeignTrainingRequestOngoing: false,
  deleteForeignTrainingSuccess: false,
  deleteForeignTrainingFailed: false,

  deleteAdditionalProfessionalQualificationRequestOngoing: false,
  deleteAdditionalProfessionalQualificationSuccess: false,
  deleteAdditionalProfessionalQualificationFailed: false,

  deletePublicationRequestOngoing: false,
  deletePublicationSuccess: false,
  deletePublicationFailed: false,

  deleteHonourRequestOngoing: false,
  deleteHonourSuccess: false,
  deleteHonourFailed: false,

  deleteRewardRequestOngoing: false,
  deleteRewardSuccess: false,
  deleteRewardFailed: false,
};

const qualificationReducer = (
  state = initialState,
  action: QualificationActions,
): QualificationState => {
  switch (action.type) {
    case GET_QUALIFICATION.GET_QUALIFICATION_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          getQualificationInfoRequestOngoing: true,
          getQualificationInfoSuccess: false,
          getQualificationInfoFailed: false,
        }),
      };
    }

    case GET_QUALIFICATION.GET_QUALIFICATION_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getQualificationInfoRequestOngoing: false,
          getQualificationInfoSuccess: true,
          getQualificationInfoFailed: false,
        }),
      };
    }

    case GET_QUALIFICATION.GET_QUALIFICATION_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          getQualificationInfoRequestOngoing: false,
          getQualificationInfoSuccess: false,
          getQualificationInfoFailed: true,
        }),
      };
    }

    case UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateEducationRequestOngoing: true,
          updateEducationSuccess: false,
          updateEducationFailed: false,
        }),
      };

    case UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentEducations =
        state && state.data ? state.data.educations : [];
      let updatedEducations = currentEducations;

      const indexOfNewEducation = currentEducations.findIndex(
        (education: any) => education.id === payload.data.id,
      );
      if (indexOfNewEducation === -1) updatedEducations.push(payload.data);
      else updatedEducations[indexOfNewEducation] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["educations"] = updatedEducations;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateEducationRequestOngoing: false,
          updateEducationSuccess: true,
          updateEducationFailed: false,
        }),
      };
    }

    case UPDATE_EDUCATION_INFO.UPDATE_EDUCATION_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateEducationRequestOngoing: false,
          updateEducationSuccess: false,
          updateEducationFailed: true,
        }),
      };
    }

    case UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateLocalTrainingRequestOngoing: true,
          updateLocalTrainingSuccess: false,
          updateLocalTrainingFailed: false,
        }),
      };

    case UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentLocalTrainings =
        state && state.data && state.data.localTrainings
          ? state.data.localTrainings
          : [];

      let updatedLocalTrainings = currentLocalTrainings;
      const indexOfNewLocalTraining = currentLocalTrainings.findIndex(
        (localTraining: any) => localTraining.id === payload.data.id,
      );
      if (indexOfNewLocalTraining === -1)
        updatedLocalTrainings.push(payload.data);
      else updatedLocalTrainings[indexOfNewLocalTraining] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["educations"] = updatedLocalTrainings;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateLocalTrainingRequestOngoing: false,
          updateLocalTrainingSuccess: true,
          updateLocalTrainingFailed: false,
        }),
      };
    }

    case UPDATE_LOCAL_TRAINING_INFO.UPDATE_LOCAL_TRAINING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateLocalTrainingRequestOngoing: false,
          updateLocalTrainingSuccess: false,
          updateLocalTrainingFailed: true,
        }),
      };
    }

    case UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateForeignTrainingRequestOngoing: true,
          updateForeignTrainingSuccess: false,
          updateForeignTrainingFailed: false,
        }),
      };

    case UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentForeignTrainings =
        state && state.data && state.data.foreignTrainings
          ? state.data.foreignTrainings
          : [];
      let updatedForeignTrainings = currentForeignTrainings;

      const indexOfNewForeignTraining = currentForeignTrainings.findIndex(
        (foreignTraining: any) => foreignTraining.id === payload.data.id,
      );
      if (indexOfNewForeignTraining === -1)
        updatedForeignTrainings.push(payload.data);
      else updatedForeignTrainings[indexOfNewForeignTraining] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["foreignTrainings"] = updatedForeignTrainings;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateForeignTrainingRequestOngoing: false,
          updateForeignTrainingSuccess: true,
          updateForeignTrainingFailed: false,
        }),
      };
    }

    case UPDATE_FOREIGN_TRAINING_INFO.UPDATE_FOREIGN_TRAINING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateForeignTrainingRequestOngoing: false,
          updateForeignTrainingSuccess: false,
          updateForeignTrainingFailed: false,
        }),
      };
    }

    case UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateAdditionalProfessionalQualificationRequestOngoing: true,
          updateAdditionalProfessionalQualificationSuccess: false,
          updateAdditionalProfessionalQualificationFailed: true,
        }),
      };

    case UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentAdditionalProfessionalQualifications =
        state && state.data && state.data.additionalProfessionalQualifications
          ? state.data.additionalProfessionalQualifications
          : [];
      let updatedAdditionalProfessionalQualifications =
        currentAdditionalProfessionalQualifications;

      const indexOfNewAdditionalProfessionalQualification =
        currentAdditionalProfessionalQualifications.findIndex(
          (additionalProfessionalQualification: any) =>
            additionalProfessionalQualification.id === payload.data.id,
        );
      if (indexOfNewAdditionalProfessionalQualification === -1)
        updatedAdditionalProfessionalQualifications.push(payload.data);
      else
        updatedAdditionalProfessionalQualifications[
          indexOfNewAdditionalProfessionalQualification
        ] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["additionalProfessionalQualifications"] =
        updatedAdditionalProfessionalQualifications;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateAdditionalProfessionalQualificationRequestOngoing: false,
          updateAdditionalProfessionalQualificationSuccess: true,
          updateAdditionalProfessionalQualificationFailed: false,
        }),
      };
    }

    case UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateAdditionalProfessionalQualificationRequestOngoing: false,
          updateAdditionalProfessionalQualificationSuccess: false,
          updateAdditionalProfessionalQualificationFailed: true,
        }),
      };
    }

    case UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updatePublicationRequestOngoing: true,
          updatePublicationSuccess: false,
          updatePublicationFailed: false,
        }),
      };

    case UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentPublications =
        state && state.data && state.data.publications
          ? state.data.publications
          : [];
      let updatedPublications = currentPublications;

      const indexOfNewPublication = currentPublications.findIndex(
        (publication: any) => publication.id === payload.data.id,
      );
      if (indexOfNewPublication === -1) updatedPublications.push(payload.data);
      else updatedPublications[indexOfNewPublication] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["publications"] = updatedPublications;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updatePublicationRequestOngoing: false,
          updatePublicationSuccess: true,
          updatePublicationFailed: false,
        }),
      };
    }

    case UPDATE_PUBLICATION_INFO.UPDATE_PUBLICATION_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updatePublicationRequestOngoing: false,
          updatePublicationSuccess: false,
          updatePublicationFailed: true,
        }),
      };
    }

    case UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateHonourRequestOngoing: true,
          updateHonourSuccess: false,
          updateHonourFailed: false,
        }),
      };

    case UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentHonours =
        state && state.data && state.data.honours ? state.data.honours : [];
      let updatedHonours = currentHonours;

      const indexOfNewHonour = currentHonours.findIndex(
        (honour: any) => honour.id === payload.data.id,
      );
      if (indexOfNewHonour === -1) updatedHonours.push(payload.data);
      else updatedHonours[indexOfNewHonour] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["honours"] = updatedHonours;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateHonourRequestOngoing: false,
          updateHonourSuccess: true,
          updateHonourFailed: false,
        }),
      };
    }

    case UPDATE_HONOUR_INFO.UPDATE_HONOUR_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateHonourRequestOngoing: false,
          updateHonourSuccess: false,
          updateHonourFailed: true,
        }),
      };
    }

    case UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateRewardRequestOngoing: true,
          updateRewardSuccess: false,
          updateRewardFailed: false,
        }),
      };

    case UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentRewards =
        state && state.data && state.data.awards ? state.data.awards : [];
      let updatedRewards = currentRewards;

      const indexOfNewReward = currentRewards.findIndex(
        (reward: any) => reward.id === payload.data.id,
      );
      if (indexOfNewReward === -1) updatedRewards.push(payload.data);
      else updatedRewards[indexOfNewReward] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["awards"] = updatedRewards;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateRewardRequestOngoing: false,
          updateRewardSuccess: true,
          updateRewardFailed: false,
        }),
      };
    }

    case UPDATE_REWARD_INFO.UPDATE_REWARD_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateRewardRequestOngoing: false,
          updateRewardSuccess: false,
          updateRewardFailed: true,
        }),
      };
    }

    case DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteEducationRequestOngoing: true,
          deleteEducationSuccess: false,
          deleteEducationFailed: false,
        }),
      };

    case DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_SUCCESS: {
      const { payload } = action as any;

      const updatedEducationsInfo =
        state && state.data && state.data.educations
          ? state.data.educations.filter(
              (education: any) => education.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["educations"] = updatedEducationsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteEducationRequestOngoing: false,
          deleteEducationSuccess: true,
          deleteEducationFailed: false,
        }),
      };
    }

    case DELETE_EDUCATION_INFO.DELETE_EDUCATION_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteEducationRequestOngoing: false,
          deleteEducationSuccess: false,
          deleteEducationFailed: true,
        }),
      };
    }

    case DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteLocalTrainingRequestOngoing: true,
          deleteLocalTrainingSuccess: false,
          deleteLocalTrainingFailed: false,
        }),
      };

    case DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedLocalTrainingsInfo =
        state && state.data && state.data.localTrainings
          ? state.data.localTrainings.filter(
              (localTraining: any) => localTraining.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["localTrainings"] = updatedLocalTrainingsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteLocalTrainingRequestOngoing: false,
          deleteLocalTrainingSuccess: true,
          deleteLocalTrainingFailed: false,
        }),
      };
    }

    case DELETE_LOCAL_TRAINING_INFO.DELETE_LOCAL_TRAINING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteLocalTrainingRequestOngoing: false,
          deleteLocalTrainingSuccess: false,
          deleteLocalTrainingFailed: true,
        }),
      };
    }

    case DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteForeignTrainingRequestOngoing: true,
          deleteForeignTrainingSuccess: false,
          deleteForeignTrainingFailed: false,
        }),
      };

    case DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedForeignTrainingsInfo =
        state && state.data && state.data.foreignTrainings
          ? state.data.foreignTrainings.filter(
              (foreignTraining: any) => foreignTraining.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["foreignTrainings"] = updatedForeignTrainingsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteForeignTrainingRequestOngoing: false,
          deleteForeignTrainingSuccess: true,
          deleteForeignTrainingFailed: false,
        }),
      };
    }

    case DELETE_FOREIGN_TRAINING_INFO.DELETE_FOREIGN_TRAINING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteForeignTrainingRequestOngoing: false,
          deleteForeignTrainingSuccess: false,
          deleteForeignTrainingFailed: true,
        }),
      };
    }

    case DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteAdditionalProfessionalQualificationRequestOngoing: true,
          deleteAdditionalProfessionalQualificationSuccess: false,
          deleteAdditionalProfessionalQualificationFailed: false,
        }),
      };

    case DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedAdditionalProfessionalQualificationsInfo =
        state && state.data && state.data.additionalProfessionalQualifications
          ? state.data.additionalProfessionalQualifications.filter(
              (foreignTraining: any) => foreignTraining.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["additionalProfessionalQualifications"] =
        updatedAdditionalProfessionalQualificationsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteAdditionalProfessionalQualificationRequestOngoing: false,
          deleteAdditionalProfessionalQualificationSuccess: true,
          deleteAdditionalProfessionalQualificationFailed: false,
        }),
      };
    }

    case DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO.DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteAdditionalProfessionalQualificationRequestOngoing: false,
          deleteAdditionalProfessionalQualificationSuccess: false,
          deleteAdditionalProfessionalQualificationFailed: true,
        }),
      };
    }

    case DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deletePublicationRequestOngoing: true,
          deletePublicationSuccess: false,
          deletePublicationFailed: false,
        }),
      };

    case DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedPublicationsInfo =
        state && state.data && state.data.publications
          ? state.data.publications.filter(
              (publication: any) => publication.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["publications"] = updatedPublicationsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deletePublicationRequestOngoing: false,
          deletePublicationSuccess: true,
          deletePublicationFailed: false,
        }),
      };
    }

    case DELETE_PUBLICATION_INFO.DELETE_PUBLICATION_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deletePublicationRequestOngoing: false,
          deletePublicationSuccess: false,
          deletePublicationFailed: true,
        }),
      };
    }

    case DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteHonourRequestOngoing: true,
          deleteHonourSuccess: false,
          deleteHonourFailed: false,
        }),
      };

    case DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedHonoursInfo =
        state && state.data && state.data.honours
          ? state.data.honours.filter(
              (honour: any) => honour.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["honours"] = updatedHonoursInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteHonourRequestOngoing: false,
          deleteHonourSuccess: true,
          deleteHonourFailed: false,
        }),
      };
    }

    case DELETE_HONOUR_INFO.DELETE_HONOUR_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteHonourRequestOngoing: false,
          deleteHonourSuccess: false,
          deleteHonourFailed: true,
        }),
      };
    }

    case DELETE_REWARD_INFO.DELETE_REWARD_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteRewardRequestOngoing: true,
          deleteRewardSuccess: false,
          deleteRewardFailed: false,
        }),
      };

    case DELETE_REWARD_INFO.DELETE_REWARD_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedRewardsInfo =
        state && state.data && state.data.awards
          ? state.data.awards.filter(
              (reward: any) => reward.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["awards"] = updatedRewardsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteRewardRequestOngoing: false,
          deleteRewardSuccess: true,
          deleteRewardFailed: false,
        }),
      };
    }

    case DELETE_REWARD_INFO.DELETE_REWARD_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteRewardRequestOngoing: false,
          deleteRewardSuccess: false,
          deleteRewardFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default qualificationReducer;
